"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _localization = require("@lt/localization");
var _rebrand = require("../../icons-react/rebrand");
var _facilities = require("../../icons-react/facilities");
var _userflow = require("../../utils/userflow");
var _CurrencyFormat = _interopRequireDefault(require("../CurrencyFormat"));
var _LabelList = require("../Label/LabelList");
var _index = require("../../proptypes/hotel/index");
var _WarningPlacesEnd = _interopRequireDefault(require("../WarningPlacesEnd"));
var _excluded = ["pricePerNight", "operator", "extras", "ltExtras", "included", "availability", "labels", "isHotelOnly", "isMobile", "isActive"]; // Icons:
// Utils:
// Components:
// PropTypes:
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var HotelOfferInfo = function HotelOfferInfo(_ref) {
  var pricePerNight = _ref.pricePerNight,
    operator = _ref.operator,
    extras = _ref.extras,
    ltExtras = _ref.ltExtras,
    included = _ref.included,
    availability = _ref.availability,
    labels = _ref.labels,
    isHotelOnly = _ref.isHotelOnly,
    isMobile = _ref.isMobile,
    isActive = _ref.isActive,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var oldPrice = (0, _get2["default"])(extras, 'previous_price');
  var cheapest = (0, _get2["default"])(extras, 'best_price') && false; // TODO: возможно чот не так с бэка приходит
  var cancellationPolicy = (0, _get2["default"])(extras, 'cancellation_policy');
  var hasLtExtras = !(0, _isEmpty2["default"])(ltExtras);
  var _useTranslation = (0, _localization.useTranslation)(),
    t = _useTranslation.t;
  var _useCurrency = (0, _localization.useCurrency)(),
    code = _useCurrency.code;
  var maxLabels = 3;
  var freeCancellation = (0, _userflow.isFreeCancellation)(cancellationPolicy);
  if (freeCancellation) maxLabels -= 1;
  var filteredLabels = labels === null || labels === void 0 ? void 0 : labels.filter(function (label) {
    return label.context.hotel === 3;
  });
  filteredLabels === null || filteredLabels === void 0 || filteredLabels.forEach(function (label) {
    return label.style = 'LABEL';
  });
  return /*#__PURE__*/_react["default"].createElement(StyledHotelOfferInfo, rest, oldPrice && /*#__PURE__*/_react["default"].createElement(StyledText, null, /*#__PURE__*/_react["default"].createElement(StyledHotPriceIconWrapper, null, /*#__PURE__*/_react["default"].createElement(StyledHotPriceIcon, null)), /*#__PURE__*/_react["default"].createElement(StyledOldPrice, {
    $isActive: isActive,
    value: oldPrice,
    currencyCode: code
  })), /*#__PURE__*/_react["default"].createElement(StyledText, null, pricePerNight > 0 && /*#__PURE__*/_react["default"].createElement(_StyledStyledNightPriceTag, {
    $isActive: isActive,
    $_css: hasLtExtras || availability ? 5 : 0
  }, /*#__PURE__*/_react["default"].createElement(_CurrencyFormat["default"], {
    value: pricePerNight,
    currencyCode: code
  }), t('hotel.carousel.night'), cheapest && /*#__PURE__*/_react["default"].createElement(StyledLikeIcon, null)), hasLtExtras && /*#__PURE__*/_react["default"].createElement(StyledGiftIcon, {
    "data-offer-extras": JSON.stringify(ltExtras)
  })), /*#__PURE__*/_react["default"].createElement(StyledWarningPlacesEnd, {
    flight: availability.flight,
    hotel: availability.hotel,
    isHotelOnly: isHotelOnly
  }), /*#__PURE__*/_react["default"].createElement(StyledLabelList, {
    labels: filteredLabels,
    maxLabels: maxLabels,
    isSmall: true,
    isMobile: isMobile
  }), freeCancellation && /*#__PURE__*/_react["default"].createElement(StyledFreeCancellationLabel, null, /*#__PURE__*/_react["default"].createElement(StyledCancellationOnIcon, null), t('hotelcard.tag.free_cancellation')), !isHotelOnly ? /*#__PURE__*/_react["default"].createElement(StyledOperator, {
    $isActive: isActive
  }, operator) : null, !(0, _isEmpty2["default"])(included) && /*#__PURE__*/_react["default"].createElement(StyledIncluded, null, included.map(function (item) {
    return String(item.name).toLowerCase();
  }).join('\n')));
};
HotelOfferInfo.defaultProps = {
  included: null,
  extras: null,
  labels: [],
  isActive: false
};
HotelOfferInfo.propTypes = {
  operator: _propTypes["default"].string.isRequired,
  pricePerNight: _propTypes["default"].number.isRequired,
  availability: _index.AvailabilityPropTypes.isRequired,
  labels: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
  isActive: _propTypes["default"]["boolean"],
  included: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string.isRequired,
    code_name: _propTypes["default"].string.isRequired
  }).isRequired),
  extras: _propTypes["default"].shape({
    previous_price: _propTypes["default"].number,
    best_price: _propTypes["default"].bool,
    cancellation_policy: _propTypes["default"].shape({
      kind: _propTypes["default"].string.isRequired,
      description: _propTypes["default"].string.isRequired
    })
  }),
  ltExtras: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]).isRequired,
    header: _propTypes["default"].string,
    description: _propTypes["default"].string
  }))
};
var StyledWarningPlacesEnd = (0, _styledComponents["default"])(_WarningPlacesEnd["default"]).withConfig({
  displayName: "HotelOfferInfo__StyledWarningPlacesEnd",
  componentId: "sc-oi8hjh-0"
})(["font-size:12px;font-style:normal;font-weight:400;line-height:14px;color:var(--orange);"]);
var StyledOldPrice = (0, _styledComponents["default"])(_CurrencyFormat["default"]).withConfig({
  displayName: "HotelOfferInfo__StyledOldPrice",
  componentId: "sc-oi8hjh-1"
})(["", ";text-decoration:line-through;"], function (_ref2) {
  var $isActive = _ref2.$isActive;
  return $isActive ? (0, _styledComponents.css)(["color:var(--black);"]) : (0, _styledComponents.css)(["color:var(--grey1);"]);
});
var StyledText = _styledComponents["default"].div.withConfig({
  displayName: "HotelOfferInfo__StyledText",
  componentId: "sc-oi8hjh-2"
})(["display:flex;align-items:center;text-align:center;font-size:12px;font-style:normal;font-weight:400;line-height:14px;"]);
var StyledIncluded = (0, _styledComponents["default"])(StyledText).withConfig({
  displayName: "HotelOfferInfo__StyledIncluded",
  componentId: "sc-oi8hjh-3"
})(["color:var(--grey1);white-space:pre;text-align:center;"]);
var StyledOperator = (0, _styledComponents["default"])(StyledText).withConfig({
  displayName: "HotelOfferInfo__StyledOperator",
  componentId: "sc-oi8hjh-4"
})(["", ";"], function (_ref3) {
  var $isActive = _ref3.$isActive;
  return $isActive ? (0, _styledComponents.css)(["color:var(--black);"]) : (0, _styledComponents.css)(["color:var(--grey1);"]);
});
var StyledHotelOfferInfo = _styledComponents["default"].div.withConfig({
  displayName: "HotelOfferInfo__StyledHotelOfferInfo",
  componentId: "sc-oi8hjh-5"
})(["display:flex;width:100%;flex-direction:column;justify-content:center;align-items:center;gap:4px;"]);
var StyledNightPriceTag = _styledComponents["default"].div.withConfig({
  displayName: "HotelOfferInfo__StyledNightPriceTag",
  componentId: "sc-oi8hjh-6"
})(["display:flex;align-items:center;", ";"], function (_ref4) {
  var $isActive = _ref4.$isActive;
  return $isActive ? (0, _styledComponents.css)(["color:var(--black);"]) : (0, _styledComponents.css)(["color:var(--grey1);"]);
});
var _StyledStyledNightPriceTag = (0, _styledComponents["default"])(StyledNightPriceTag).withConfig({
  displayName: "HotelOfferInfo___StyledStyledNightPriceTag",
  componentId: "sc-oi8hjh-7"
})(["margin-right:", "px;"], function (p) {
  return p.$_css;
});
var StyledHotPriceIconWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HotelOfferInfo__StyledHotPriceIconWrapper",
  componentId: "sc-oi8hjh-8"
})(["position:relative;top:1px;margin-right:3px;"]);
var StyledHotPriceIcon = (0, _styledComponents["default"])(_rebrand.Hot).withConfig({
  displayName: "HotelOfferInfo__StyledHotPriceIcon",
  componentId: "sc-oi8hjh-9"
})(["height:11px;"]);
var StyledGiftIcon = (0, _styledComponents["default"])(_facilities.Gift).withConfig({
  displayName: "HotelOfferInfo__StyledGiftIcon",
  componentId: "sc-oi8hjh-10"
})(["position:relative;top:-0.5px;width:16px;height:16px;& .gift_svg__gift-icon-body{fill:", ";}& .gift_svg__gift-icon-border{fill:", ";}& .gift_svg__gift-icon-bow{stroke:", ";}"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.yellowBase;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.blackLight;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.blackLight;
});
var StyledLikeIcon = (0, _styledComponents["default"])(_rebrand.Like).withConfig({
  displayName: "HotelOfferInfo__StyledLikeIcon",
  componentId: "sc-oi8hjh-11"
})(["position:relative;top:-2px;height:16px;margin-left:1px;"]);
var StyledCancellationOnIcon = (0, _styledComponents["default"])(_rebrand.CancellationOn).withConfig({
  displayName: "HotelOfferInfo__StyledCancellationOnIcon",
  componentId: "sc-oi8hjh-12"
})(["margin-right:4px;height:18px;"]);
var StyledFreeCancellationLabel = _styledComponents["default"].div.withConfig({
  displayName: "HotelOfferInfo__StyledFreeCancellationLabel",
  componentId: "sc-oi8hjh-13"
})(["display:flex;align-items:center;justify-content:center;"]);
var StyledLabelList = (0, _styledComponents["default"])(_LabelList.LabelList).withConfig({
  displayName: "HotelOfferInfo__StyledLabelList",
  componentId: "sc-oi8hjh-14"
})(["align-items:center;max-width:", ";overflow:hidden;"], function (props) {
  return props.isMobile ? '100%' : '150px';
});
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(HotelOfferInfo);